import React from 'react';
import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from 'antd';

const Badge = (props: BaseBadgeProps) => <BaseBadge {...props} />;

export default Badge;
